import { FC } from 'react';
import { useSelector } from 'react-redux';
// import Table from '../middlewares/Tokenmiddleware'
import Table from '../middlewares/InitMiddleware'
import MyProvider from '../memory/memr';

import React from 'react';
import { motion } from 'framer-motion';
import { useTable } from 'react-table';
import { COLUMNS } from '../config/Transaction/columns';

export interface TableProps {
    tblData: any,
    tblColumns: any
}

const cols = COLUMNS

const AdminInstance: FC<{}> = () => {

    const tableStateColumns = useSelector((state: any) => state.rootReducer.admins?.adminData?.columns) || cols;
    const tableStateRows = useSelector((state: any) => state.rootReducer.admins?.adminData?.dataRows) || [];
    const tableStateLoading = useSelector((state: any) => state.rootReducer.admins?.isLoading);
    const tableStateError = useSelector((state: any) => state.rootReducer.admins?.isError);
    const tableStateLogout = useSelector((state: any) => state.rootReducer.admins?.isLogout) || false;

    // console.log("offer data", tableStateRows, tableStateColumns, tableStateLoading, tableStateError, tableStateLogout);
    // Memos
    const data: any = React.useMemo(() => tableStateRows, [tableStateRows]);
    const columns: any = React.useMemo(() => tableStateColumns, [tableStateColumns]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns,
        data
    });


    return (
        <MyProvider>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <Table
                    getTableProps={getTableProps}
                    getTableBodyProps={getTableBodyProps}
                    headerGroups={headerGroups}
                    rows={rows}
                    prepareRow={prepareRow}
                    tbleDataMiddleware={tableStateRows}
                    tableStateLoading={tableStateLoading}
                    tableStateError={tableStateError}
                    // jwtToken={clientToken}
                    // userData={clientToken}
                    tableStateLogout={tableStateLogout}
                />
            </motion.div>
            </MyProvider>

    )
}

export default AdminInstance
